<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.arair.ir\/storage\/asset\/Untitled-1.gif","alt":"mix it web"},...{}}' :style='""' class="col-lg-9 mx-auto" ></m-img><m-hafez-1 v-bind='{...{},...{}}' :style='"background : #ffffffcf;\nborder-radius:25px;"' class="col-lg-8 mx-auto border shadow" ></m-hafez-1><m-div v-bind='{...{},...{}}' :style='"background : #ffffffcf;\nborder-radius:25px;"' class="col-12 my-3 border" >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='""' class="col-12 text-center my-5 h3" >
                <template #default>برای دریافت تخفیف شماره تماس خود  را وارد کنید.    </template>
                </m-h1><m-form-single-1 v-bind='{...{"itemClass":"col-lg-12 mb-3 mx-auto text-center","formId":1,"redirectToDashboard":false,"redirectDirectLink":""},...{}}' :style='""' class="my-5 " ></m-form-single-1></template>
                </m-div></template>
                </m-div></template>
                </m-div><m-snow-1 v-bind='{...{},...{}}' :style='""' class="" ></m-snow-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img'; import mHafez1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Hafez/Hafez1'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mFormSingle1 from '@moeinmdn/miw-alpha-components/src/package/Form/FormSingle/FormSingle1'; import mSnow1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Snow/Snow1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mImg,mHafez1,mH1,mFormSingle1,mSnow1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
